module.exports = __webpack_public_path__ + "img/toolbox.75ef16e2.svg";